// Build-time configuration (Vite inlines VITE_* at build). Runtime facts that
// the server owns — the operating mode, the role, flags — come from
// GET /api/erp/me and GET /api/business/v1/config (see me.ts / config.ts).

const env = import.meta.env;

export type ErpMode = 'online' | 'node';

/** Base for every API call. Dev + nginx proxy /api/business and /api/erp. */
export const API_BASE: string = (env.VITE_API_BASE ?? '/api').replace(/\/$/, '');

/**
 * Mock interceptor toggle. Unset → ON only for the dev server / tests
 * (`npm run dev` works with no backend) and OFF in a production build, so a
 * plain `npm run build` never ships the interceptor (e2e login-today-booking-8).
 * An explicit VITE_USE_MOCKS=true|false always wins.
 */
export function mocksDefault(raw: string | undefined, dev: boolean): boolean {
  if (raw != null && raw !== '') return raw !== 'false';
  return dev;
}
export const USE_MOCKS: boolean = mocksDefault(env.VITE_USE_MOCKS, !!env.DEV);

/** Runtime switches set at boot (the mock interceptor flips `mocks` when installed). */
export const runtimeFlags = { mocks: USE_MOCKS };

/** Build-time default operating mode; GET /me → mode overrides it at runtime. */
export const BUILD_MODE: ErpMode = env.VITE_ERP_MODE === 'node' ? 'node' : 'online';

/** Authentik business application (online mode). */
export const BUSINESS_AUTH = {
  issuerUrl: env.VITE_BUSINESS_ISSUER_URL ?? '',
  clientId: env.VITE_BUSINESS_CLIENT_ID ?? 'business-web',
  brandHost: env.VITE_BUSINESS_BRAND_HOST ?? '',
};

/** Root of a business's public page (<base>/<slug>), no trailing slash. */
export const PUBLIC_PAGE_BASE_URL: string = (env.VITE_PUBLIC_PAGE_BASE_URL ?? 'https://ihjizli.daralulum.com/b').replace(/\/$/, '');

/** Router basename. The public host is erp.<…> so the app lives at '/'. */
export const BASE_PATH: string = env.VITE_BASE_PATH ?? '/';
